export enum DocusignStatus {
  Created = 'created',
  Sent = 'sent',
  Delivered = 'delivered',
  Signed = 'signed',
  Completed = 'completed',
  Declined = 'declined',
  Voided = 'voided',
}
